import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import CategoryHeading from '@fuww/library/src/CategoryHeading';
import SpacingContainer
  from '@fuww/library/src/SpacingContainer';
import breakpoints from '@fuww/library/src/Theme/breakpoints';
import { RelatedItemContainer, RelatedItem }
  from '@fuww/library/src/List/RelatedItem';
import CardWithLink from '../../CardWithLink';
import articlesQuery from '../../../lib/queries/news/articlesQuery.graphql';
import {
  relatedCategoryIds as categoryIds,
} from '../../../lib/mainCategoryIds';
import withQuery from '../../../lib/withQuery';
import { useSiteContext } from '../../SiteContext';
import messages from '../../../lib/messages.json';
import {
  relatedNewsImageConfigurations,
} from '../../../lib/imageConfigurations';

const errorMessage = 'Error while loading news articles...';

const RelatedNews = ({
  data,
  variables,
  articleId,
}) => {
  const { tagSlugs, ...relatedVariables } = variables;

  return (
    <>
      <RelatedItemContainer>
        {data.universalNewsArticles.map((article) => (
          <RelatedItem key={article.id}>
            <CardWithLink
              newsArticle={article}
              variables={variables}
              withPageMargins
              sizes={`
              (min-width: 1100px) 220px,
              (min-width: ${breakpoints.lg}px) 21vw,
              (min-width: ${breakpoints.sm}px) 31vw,
              100vw
            `}
            />
          </RelatedItem>
        ))}
      </RelatedItemContainer>
      {tagSlugs && (
        // eslint-disable-next-line no-use-before-define
        <RelatedNewsWithQuery
          query={articlesQuery}
          variables={{
            ...relatedVariables,
            relatedToIds: [articleId],
            notInIds: data.universalNewsArticles.map(({ id }) => id),
            sort: 'RELEVANCE_AND_DATE',
          }}
          errorMessage={errorMessage}
          articleId={articleId}
        />
      )}
    </>
  );
};

RelatedNews.propTypes = {
  data: PropTypes.shape({
    universalNewsArticles: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
    })).isRequired,
  }),
  variables: PropTypes.shape({
    tagSlugs: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  articleId: PropTypes.number.isRequired,
};

RelatedNews.defaultProps = {
  data: {},
};

const RelatedNewsWithQuery = withQuery(RelatedNews);

const RelatedNewsWithData = ({
  articleId, tagSlugs,
}) => {
  const { newsboard } = useSiteContext();
  const intl = useIntl();

  const variables = {
    newsboard,
    withoutDescriptionAndCreator: true,
    withoutSummaryAndLabel: false,
    sort: 'CREATED_AT',
    limit: 3,
    notInIds: articleId,
    categoryIds,
    imageConfigurations: relatedNewsImageConfigurations,
    tagSlugs,
  };

  return (
    <>
      <CategoryHeading>
        {intl.formatMessage(messages.relatedNews)}
      </CategoryHeading>
      <SpacingContainer />
      <RelatedNewsWithQuery
        query={articlesQuery}
        variables={variables}
        errorMessage={errorMessage}
        articleId={articleId}
      />
    </>
  );
};

RelatedNewsWithData.propTypes = {
  tagSlugs: PropTypes.arrayOf(PropTypes.string),
  articleId: PropTypes.number,
};

RelatedNewsWithData.defaultProps = {
  articleId: null,
  tagSlugs: null,
};

export default RelatedNewsWithData;
